module.exports = __webpack_public_path__ + "static/media/teleMedi.11528895.svg";